









import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class StPercentInput extends Vue {
  @Prop() value!: number;

  @Emit('input')
  input(val: string){
    let res = parseInt(val);

    if(!res){
      return 0;
    }

    return res;
  }
}
